import React, { useEffect, useState } from "react";
import Input from "../../../../components/Input";
import InputRadio from "../../../../components/InputRadio";
import { getIndexFromObjectArray } from "../../../../helpers/helpers";
import { convertToPercentage } from "../../../../helpers/masks";
import { createOptions } from "../../../../helpers/selects";

const Percentage = ({param, productParams, setProductParams}) => {
    const [index, setIndex] = useState(null);

    useEffect(() => {
        let toIndex = getIndexFromObjectArray(productParams, 'id', param.id);
        setIndex(toIndex);
    }, [productParams]);

    const handleParamChange = value => {
        setProductParams(prev => {
            let toProductParams = [...prev];
            toProductParams[index].value = value;
            return toProductParams;
        });
    }

    return (
        <>
            {index !== null &&
                <>
                    <div className="modal-section-title">
                        <div className="left">
                            <h2>{param.name}</h2>
                        </div>
                    </div>
                    <div className="section">
                        <div className="row">
                            <div className="col-3">
                                <Input 
                                    label={`Porcentagem`}
                                    value={productParams[index].value ?? convertToPercentage('0')}
                                    change={handleParamChange}
                                    mask={`convertToPercentage`}
                                />
                            </div>
                        </div>
                    </div>
                </>
            }
        </>
    );
}

export default Percentage;